import { Routes } from "@angular/router";
import { DefaultLayoutComponent } from "./layout";
import { AuthGuard } from "@infra-adapters/guards/auth.guard";
import { DashboardAccessGuard } from "@infra-adapters/guards/dashboard-access.guard";
import { InvalidSessionGuard } from "@infra-adapters/guards/invalidSession.guard";

export const routes: Routes = [
  {
    path: "",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      title: "Inicio",
    },
    children: [
      {
        path: "dashboard",
        canActivate: [DashboardAccessGuard],
        loadChildren: () =>
          import("./views/dashboard/routes").then((m) => m.routes),
      },
      {
        path: "prestaciones",
        data: {
          title: "Prestaciones",
        },
        loadChildren: () =>
          import("./views/prestaciones/routes").then((m) => m.routes),
      },
      {
        path: "usuarios-admin",
        data: {
          title: "Usuarios",
        },
        loadChildren: () =>
          import("./views/usuarios-admin/routes").then((m) => m.routes),
      },
      {
        path: "solicitudes-registro",
        redirectTo: "usuarios-admin",
        pathMatch: "full",
      },
      {
        path: "solicitudes-registro/:id",
        redirectTo: "usuarios-admin/:id",
      },
      {
        path: "roles-admin",
        data: {
          title: "Roles y permisos",
        },
        loadChildren: () =>
          import("./views/roles-admin/routes").then((m) => m.routes),
      },
      {
        path: "archivos-almacenamiento",
        data: {
          title: "Archivos",
        },
        loadChildren: () =>
          import("./views/archivos-almacenamiento/routes").then(
            (m) => m.routes,
          ),
      },
      {
        path: "ia-incidentes",
        data: {
          title: "Incidentes IA",
        },
        loadChildren: () =>
          import("./views/ia-incidentes/routes").then((m) => m.routes),
      },
      {
        path: "tickets-ayuda",
        data: {
          title: "Tickets de ayuda",
        },
        loadChildren: () =>
          import("./views/tickets-ayuda/routes").then((m) => m.routes),
      },
      {
        path: "mi-cuenta",
        data: {
          title: "Mi cuenta",
        },
        loadChildren: () =>
          import("./views/mi-cuenta/routes").then((m) => m.routes),
      },
      {
        path: "membresias-admin",
        data: {
          title: "Membresías",
        },
        loadChildren: () =>
          import("./views/membresias-admin/routes").then((m) => m.routes),
      },
      {
        path: "terminos-admin",
        data: {
          title: "Términos y Condiciones",
        },
        loadChildren: () =>
          import("./views/terminos-admin/routes").then((m) => m.routes),
      },
      {
        path: "noticias",
        data: {
          title: "Novedades",
        },
        loadChildren: () =>
          import("./views/noticias/routes").then((m) => m.routes),
      },
      {
        path: "catalogos-prestacion",
        data: {
          title: "Catálogos de prestación",
        },
        loadChildren: () =>
          import("./views/catalogos-prestacion/routes").then((m) => m.routes),
      },
      {
        path: "banners-admin",
        data: {
          title: "Banners",
        },
        loadChildren: () =>
          import("./views/banners-admin/routes").then((m) => m.routes),
      },
      {
        path: "bandeja-operacional",
        data: {
          title: "Bandeja Operacional",
        },
        loadChildren: () =>
          import("./views/bandeja-operacional/routes").then((m) => m.routes),
      },
      {
        path: "notificaciones",
        data: {
          title: "Notificaciones",
        },
        loadChildren: () =>
          import("./views/notificaciones/routes").then((m) => m.routes),
      },
    ],
  },
  {
    path: "404",
    loadComponent: () =>
      import("./views/pages/page404/page404.component").then(
        (m) => m.Page404Component,
      ),
    data: {
      title: "Página no encontrada",
    },
  },
  {
    path: "500",
    loadComponent: () =>
      import("./views/pages/page500/page500.component").then(
        (m) => m.Page500Component,
      ),
    data: {
      title: "Error del servidor",
    },
  },
  {
    path: "login",
    loadComponent: () =>
      import("./views/pages/login/login.component").then(
        (m) => m.LoginComponent,
      ),
    canActivate: [InvalidSessionGuard],
    data: {
      title: "Iniciar sesión",
    },
  },
  {
    path: "recuperar-contrasena",
    loadComponent: () =>
      import("./views/pages/recuperar-contrasena/recuperar-contrasena.component").then(
        (m) => m.RecuperarContrasenaComponent,
      ),
    canActivate: [InvalidSessionGuard],
    data: {
      title: "Recuperar contraseña",
    },
  },
  {
    path: "reset-password",
    loadComponent: () =>
      import("./views/pages/resetear-contrasena/resetear-contrasena.component").then(
        (m) => m.ResetearContrasenaComponent,
      ),
    canActivate: [InvalidSessionGuard],
    data: {
      title: "Nueva contraseña",
    },
  },
  {
    path: "register",
    loadComponent: () =>
      import("./views/pages/register/register.component").then(
        (m) => m.RegisterComponent,
      ),
    data: {
      title: "Registro",
    },
  },
  { path: "**", redirectTo: "dashboard" },
];
